export enum AppBottomTab {
  CREATOR = 'creator',
  MYPAGE = 'mypage',
  POPUP = 'popup',
  SHOP = 'shop',
  HOME = 'home',
}

export enum AppBottomTabEventName {
  TAB_LEAVE = 'tab-leave',
  TAB_ENTER = 'tab-enter',
}

// 이벤트 데이터 인터페이스
export interface AppBottomTabEventData {
  eventName: AppBottomTabEventName;
  currentTabName: AppBottomTab;
}

export interface AppFocusEventData {
  is_focused: boolean;
}

/**
 * 앱 이벤트를 처리하는 클래스
 */
export class AppEventHandler {
  // 타입 가드: 탭 이벤트 데이터인지 확인
  public static isTabEventData(data: object): data is AppBottomTabEventData {
    return data && typeof data === 'object' && 'eventName' in data && 'currentTabName' in data;
  }

  // 타입 가드: 포커스 이벤트 데이터인지 확인
  public static isFocusEventData(data: object): data is AppFocusEventData {
    return data && typeof data === 'object' && 'is_focused' in data && typeof data.is_focused === 'boolean';
  }

  // 탭 변경 이벤트 콜백 등록
  public static delegateAppTabEvent(callback: (data: AppBottomTabEventData) => void) {
    // window 이벤트 리스너
    window.addEventListener('message', (e: MessageEvent) => {
      try {
        const data = JSON.parse(e.data);
        if (AppEventHandler.isTabEventData(data)) {
          callback(data);
        }
      } catch (error) {
        // 파싱 오류 무시
      }
    });

    // document 이벤트 리스너
    document.addEventListener('message' as any, (e: Event) => {
      try {
        const messageEvent = e as unknown as MessageEvent;
        const data = JSON.parse(messageEvent.data);
        if (AppEventHandler.isTabEventData(data)) {
          callback(data);
        }
      } catch (error) {
        // 파싱 오류 무시
      }
    });
  }

  // 포커스 변경 이벤트 콜백 등록
  public static delegateAppFocusEvent(callback: (data: AppFocusEventData) => void) {
    // window 이벤트 리스너
    window.addEventListener('message', (e: MessageEvent) => {
      try {
        const data = JSON.parse(e.data);
        if (AppEventHandler.isFocusEventData(data)) {
          callback(data);
        }
      } catch (error) {}
    });

    // document 이벤트 리스너
    document.addEventListener('message' as any, (e: Event) => {
      try {
        const messageEvent = e as unknown as MessageEvent;
        const data = JSON.parse(messageEvent.data);

        if (AppEventHandler.isFocusEventData(data)) {
          callback(data);
        }
      } catch (error) {}
    });
  }
}
